import React from "react"
import styled from "styled-components"

const CustomFigure = styled.figure`
    width: 100%;
    margin: 1rem 0 0 0 !important;
    display: grid;
    place-items: center;
`

const ResponsiveVideoContainer = styled.video`
  width: calc(100% - var(--safety-padding) * 2 - 4px - 1rem);
  height: ${props =>
    props.ratio
      ? `min(calc(100vw * ${props.ratio}), 582px);`
      : "min(calc(100vw * 9 / 17), 582px);"};
  border: 2px solid var(--color-theme-accent);
  padding: 0.5rem;
  border-radius: 1rem;
`
const ResponsiveIFrameContainer = styled.iframe`
  width: calc(100% - var(--safety-padding) * 2 - 4px - 1rem);
  height: ${props =>
    props.ratio
      ? `min(calc(100vw * ${props.ratio}), 582px);`
      : "min(calc(100vw * 9 / 17), 582px);"};
  border: 2px solid var(--color-theme-accent);
  padding: 0.5rem;
  border-radius: 1rem;
`

function ResponsiveVideo(props) {
  const videoURL = props.src
  const YouTubeFlag = props.src.includes("youtube") ? true : false
  if (YouTubeFlag) {
    return (
      <CustomFigure>
        <ResponsiveIFrameContainer
          ratio={props.ratio}
          src={videoURL}
          title={props.title ? props.title : "Video player"}
          frameborder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          sandbox
        ></ResponsiveIFrameContainer>
        <figcaption>{props.title}</figcaption>
      </CustomFigure>
    )
  }
  return (
    <CustomFigure>
      <ResponsiveVideoContainer
        ratio={props.ratio}
        src={videoURL}
        title={props.title ? props.title : "Video player"}
        controls="true"
      ></ResponsiveVideoContainer>
      <figcaption>{props.title}</figcaption>
    </CustomFigure>
  )
}

export default ResponsiveVideo
